import React from "react";
import { withRouter } from "react-router-dom";
import { flowRight as compose } from 'lodash';
import SlideInfo from "../SlideInfo/SlideInfo";
import "./Slide.scss";

class Slide extends React.Component<any, any> {
  private rootRef = React.createRef<HTMLDivElement>();

  componentDidMount() { this.syncInert(); }
  componentDidUpdate(prev: any) {
    if (prev.isActive !== this.props.isActive || prev.isInfoActive !== this.props.isInfoActive) {
      this.syncInert();
    }
  }

  // MET2-2891: every slide renders simultaneously with opacity:1, so every
  // slide's CTAs (Watch Now / Listen Now / Start Free Trial / Login) end up
  // in the page Tab order — six slides × ~4 focusables = ~24 tab stops
  // through visually identical positions. Mark non-active slides `inert` so
  // screen readers and Tab skip them; the active slide is normal-interactive.
  // Using DOM property (not the JSX attribute) for React 17 compat.
  //
  // ⚠️ MET2-2953: gate on `isInfoActive` (which slide's overlay the user can
  // SEE) and not `isActive` (which slide the scroll position has reached).
  // Those two differ for the whole second half of every slide transition, and
  // keying `inert` to the wrong one made the visible play button dead to
  // clicks until the previous slide was fully gone.
  // Context: docs/components/hero-slide-ownership.md
  syncInert = () => {
    const el = this.rootRef.current;
    if (!el) return;
    // `undefined` (legacy callers that don't pass the prop) is treated as
    // "leave the DOM alone". `isInfoActive` wins when both are supplied.
    const gate = this.props.isInfoActive !== undefined
      ? this.props.isInfoActive
      : this.props.isActive;
    const shouldBeInert = gate === false;
    if ((el as any).inert !== shouldBeInert) (el as any).inert = shouldBeInert;
  };

  render() {
    const { image, index, zIndex, isActive, isInfoActive, heroManaged } = this.props;
    const visible = isInfoActive !== undefined ? isInfoActive : isActive;
    // Match the prior default behavior when neither prop is passed (legacy
    // ScreenParser etc): first slide is the active one.
    const activeForClass = visible !== undefined ? !!visible : index === 0;
    // ⚠️ MET2-2953: when Hero drives this slide, the className MUST be a
    // constant string. Hero writes `active` / `inactive` / `info-active` onto
    // this element imperatively from its scroll handler, and React rewrites
    // the whole class attribute whenever the string it rendered changes —
    // silently dropping those classes on the two slides either side of a
    // transition, which is what left a white band under the hero with the
    // title box floating over it. A constant string is never rewritten after
    // mount, so the imperative classes survive.
    // Context: docs/components/hero-slide-ownership.md
    const className = heroManaged
      ? "Slide"
      : `Slide ${activeForClass ? "info-active" : ""}`;
    return (
      <div
        ref={this.rootRef}
        className={className}
        data-slide-index={index}
        aria-hidden={visible === false ? true : undefined}
        style={{zIndex: zIndex}}
      >
        <div className="Slide-overlay-image">
          <img src={image} alt="" />
        </div>
        <SlideInfo {...this.props} />
      </div>
    )
  }
};

export default compose(withRouter)(Slide);
